import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class TpIntegrationsCacheService {
    private cache: Record<string, unknown> = {};

    get(key: string) {
        return this.cache[key];
    }

    set(key: string, value: any) {
        this.cache[key] = value;
    }
}
